import { Diff, Debounce } from '@/utils'
import { mergeDeepRight } from 'ramda'
import ModelFactory from '@/models/utils/factory'

export default function (options = {}) {
  let {
    model,
    source = 'item',
    destination = 'data',
    guard = false,
    transform = {},
    preTransform,
    onUpdate = () => {},
    rules = [],
  } = options

  if (typeof model === 'object') model = ModelFactory(model)

  return {
    watch: {
      [destination]: {
        handler: Debounce(function () {
          this.checkChanges()
        }, 300),
        deep: true,
      },
    },
    data() {
      return {
        [destination]: null,
        hasChanges: false,
      }
    },
    methods: {
      checkChanges() {
        this.hasChanges = Boolean(
          Object.keys(this.getData({ diff: true, transform: mergeDeepRight(preTransform, transform) })).length,
        )
        return this.hasChanges
      },
      getData(options = {}) {
        let { diff = false, transform: innerTransform = transform } = options

        let initialValue = source ? model.call(this, this[source], { transform: innerTransform }) : {}
        let newValue = model.call(this, this[destination], { transform: innerTransform })

        if (diff) return Diff(initialValue, newValue, { strategy: 'diff', rules })
        return newValue
      },
      resetData(options = {}) {
        let { transform = preTransform } = options
        this[destination] = model.call(this, source ? this[source] : undefined, { transform })
      },
    },
    beforeRouteLeave(to, from, next) {
      if (!guard || !this.checkChanges()) return next()

      const answer = window.confirm(this.$t('unsavedChangesDialog'))
      if (answer) next()
      else next(false)
    },
    created() {
      if (guard) {
        window.onbeforeunload = () => {
          if (this.checkChanges()) return true
        }
      }

      if (!source) return this.resetData()

      this.$watch(
        source,
        (val, oldVal = {}) => {
          const diff = Diff(
            model.call(this, oldVal, { transform: preTransform }),
            model.call(this, val, { transform: preTransform }),
            { strategy: 'diff', rules },
          )

          if (Object.keys(oldVal).length && !Object.keys(diff).length) return

          this[destination] = model.call(this, val, { transform: preTransform })
          onUpdate.call(this)
        },
        {
          deep: true,
          immediate: true,
        },
      )
    },
    beforeDestroy() {
      if (guard) window.onbeforeunload = null
    },
  }
}
